/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * WifiOffIcon
 */
export default class WifiOffIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M1.707.293l22 22a1 1 0 11-1.414 1.414l-6.64-6.64a.998.998 0 01-.853-.167c-1.647-1.236-3.97-1.236-5.719.014a1 1 0 11-1.162-1.628 6.988 6.988 0 014.67-1.285l-2.722-2.72c-1.474.323-2.938 1.056-4.242 2.1a1 1 0 11-1.25-1.562c1.192-.953 2.507-1.691 3.871-2.158L5.875 7.29A16.697 16.697 0 002.05 9.76 1 1 0 01.749 8.24a18.823 18.823 0 013.63-2.445L.294 1.707A1 1 0 011.707.293zM12 19.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.147-9.294a12.31 12.31 0 012.504 1.635 1 1 0 01-1.302 1.518 10.333 10.333 0 00-2.096-1.365 1 1 0 01.894-1.788zm6.113-1.957a1 1 0 11-1.32 1.502c-3.088-2.713-7.114-4.03-11.147-3.655a1 1 0 01-.186-1.992c4.583-.426 9.153 1.07 12.653 4.145z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

